import {Component, Input, OnInit} from '@angular/core';
import {IInvitation} from '@app/models/signup';

@Component({
  selector: 'app-invitation-b2b-accepted',
  templateUrl: './invitation-b2b-accepted.component.html',
  styleUrls: ['./invitation-b2b-accepted.component.scss']
})
export class InvitationB2BAcceptedComponent implements OnInit {
  @Input() invitation: IInvitation;
  @Input() type: 'client' | 'partner';
  @Input() partnershipId?: number;
  @Input() selectedAccount?: number;

  endpoints = window['ENDPOINTS'];
  account = window['CURRENT_ACCOUNT'];
  managerLink: string;

  constructor() {
  }

  get isPartner(): boolean {
    return this.type === 'partner';
  }

  ngOnInit(): void {
    this.managerLink = this.isPartner
      ? `${this.endpoints?.manager}/v3/${this.account.id}/ng/accounts/reseller-space/client/${this.partnershipId}/details`
      : `${this.endpoints?.manager}/v3/${this.selectedAccount ? this.selectedAccount : this.account.id}/ng/accounts/client-space/partner/${this.partnershipId}`;
  }
}
